import { Bell, Calendar, Plus } from 'lucide-react';
import type { VistaPantalla } from '../types';

interface Props {
  totalClientes: number;
  totalProximas: number;
  vistaActual: VistaPantalla;
  onAlternarVista: () => void;
  onProbarNotificacion: () => void;
  onProbarAlarma: () => void;
  onNuevaCita: () => void;
}

export function Encabezado({
  totalClientes,
  totalProximas,
  vistaActual,
  onAlternarVista,
  onProbarNotificacion,
  onProbarAlarma,
  onNuevaCita,
}: Props) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
            <Calendar className="text-indigo-600" size={32} />
            Mis Citas
          </h1>
          <p className="text-gray-600 mt-1">
            {totalClientes} clientes registrados • {totalProximas} citas próximas
          </p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <button
            onClick={onAlternarVista}
            className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-3 py-2 rounded-lg transition-colors text-sm"
          >
            {vistaActual === 'lista' ? '📅 Calendario' : '📋 Lista'}
          </button>
          <button
            onClick={onProbarNotificacion}
            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-lg text-sm"
          >
            🔔 Prueba
          </button>
          <button
            onClick={onProbarAlarma}
            className="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-lg text-sm"
          >
            🚨 Alarma
          </button>
          <button
            onClick={onNuevaCita}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg flex items-center gap-2 transition-colors shadow-md"
          >
            <Plus size={20} />
            Nueva Cita
          </button>
        </div>
      </div>
    </div>
  );
}

export function BannerNotificaciones() {
  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 p-4 mb-6 rounded-lg">
      <div className="flex items-start gap-3">
        <Bell className="text-amber-600 mt-1" size={20} />
        <div className="text-sm text-amber-800">
          <p className="font-semibold">Sistema de notificaciones activo:</p>
          <ul className="mt-2 space-y-1 ml-4">
            <li>• 8:00 AM el día de la cita (recordatorio)</li>
            <li>• 1.5 horas antes de la cita (recordatorio)</li>
            <li>
              • 15 minutos antes 🚨 <strong>(ALARMA URGENTE)</strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
